<template>
  <div class="slo-price-info price-info flex flex-col items-start justify-start">
    <p v-if="product?.estimatedShipDate" class="price-info--shipping-date c-green-400 text-sm">
      {{ 'Estimated ship date' | t }}: {{ product?.estimatedShipDate }}
    </p>
    <div v-if="hasRestrictions" class="restriction-messages">
      <div
        v-if="restrictionMessage?.type && restrictionMessage?.message"
        v-for="(restrictionMessage, index) in restrictionMessages"
        :key="`restriction-message-${index}`"
        :class="{
          'restriction-message': true,
          [`restriction-type-${restrictionMessage.type}`]: true
        }"
      >
        <div class="restriction-message--inner">
          <SloIcon
            :name="restrictionMessage.type === 'error' ? 'circle-exclamation' : 'triangle-exclamation'"
            size="lg"
          />
          <p class="fw-strong text-sm">
            {{ restrictionMessage.message }}
          </p>
          <slot name="restricted-messages-actions" />
        </div>
      </div>
    </div>
    <div
      v-if="product?.price"
      class="price-info--price-wrapper flex items-center justify-start"
    >
      <p class="price-info--price">
        {{ product?.price?.formattedValue }}
      </p>
      <slot />
    </div>
  </div>
</template>

<script>
import t from '../../js/main/i18n';
import SloIcon from './SloIcon.vue';

export default {
  name: 'SloProductMeta',
  components: {
    SloIcon
  },
  filters: {
    t
  },
  props: {
    product: {type: Object, required: true}
  },
  data() {
    return {
      hasRestrictions: false,
      restrictionMessages: []
    };
  },
  mounted() {
    this.restrictionMessages = this.product?.restrictedMessage || [];
    this.hasRestrictions = this.restrictionMessages.length > 0;
  }
};
</script>

<style lang="scss" scoped>
@import '../../scss/system';

.price-info {
  &--price-wrapper {
    margin-block-start: 0.8rem;
    margin-block-end: 1.6rem;
    gap: 0.4rem;
  }

  &--shipping-date {
    margin-block-start: 1.6rem;
    font-weight: 500;
  }

  &--price {
    font-size: 2.2rem;
    text-decoration: none !important;
    margin-block: 0 !important;
  }
}

.restriction-message {
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 1.6rem;
  margin-block: 1.6rem;
  padding: 1.6rem;
  background-color: $color-gray-100;
  border: 1px solid $color-gray-400;
  border-radius: 0.8rem;

  &.restriction-type-warning {
    :deep(svg) {
      fill: $color-orange-500;
    }
  }
  &.restriction-type-error {
    :deep(svg) {
      fill: $color-red-400;
    }
  }

  &--inner {
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: start;
    gap: 1rem;
  }
}

.slo-card--add-to-cart-wrapper {
  .price-info {
    &--shipping-date {
      margin-block: 0;
    }
  }
}

.parts-shop--product-meta {
  .price-info--shipping-date {
    display: none;
  }

  .price-info--price-wrapper {
    margin-block-start: 0;

    @media (min-width: 1200px) {
      width: 100%;
      justify-content: center;
    }
  }

  .price-info--price {
    font-size: 1.6rem;
  }
}
</style>
